<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else-if="initialized">
            <div style="margin: -20px -20px -20px -20px;">
                <div class="card-header bg-white">
                    <div class="d-flex">
                        <div class="ml-auto text-right">
                            <limitless-button @click="editSchedule(0)" icon="icon-plus3">Nytt schema</limitless-button>
                        </div>
                    </div>
                </div>
                <div v-if="user" class="card-body border-bottom">
                    <ValidationObserver ref="employmentform">
                        <form @submit.prevent="saveEmployment">
                            <div class="row align-items-center">
                                <div v-if="schedules.length === 0" class="col-md-4">
                                    <input-with-validation
                                        label="Arbetstimmar per vecka"
                                        vid="workhours_per_week"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        required
                                        v-model="user.workhours_per_week"
                                    ></input-with-validation>
                                </div>
                                <div class="col-md-8 mb-3">
                                    <div class="custom-control custom-checkbox">
                                        <input
                                            id="workhours-include-holidays"
                                            v-model="user.workhours_include_holidays"
                                            type="checkbox"
                                            class="custom-control-input"
                                        >
                                        <label for="workhours-include-holidays" class="custom-control-label">Dra ej av helgdagar från förväntat arbetstid</label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end">
                                <limitless-button ref="btnsaveemployment" type="button" @click="saveEmployment" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
                <div>
                    <table v-if="schedules.length > 0" class="table table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Gäller från</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(schedule, s_idx) in schedules"
                                :key="'s-' + s_idx"
                            >
                                <td><a href="" @click.prevent="editSchedule(schedule.id)">{{ schedule.id }}</a></td>
                                <td><a href="" @click.prevent="editSchedule(schedule.id)">{{ schedule.valid_from }}</a></td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else style="padding: 20px;"><i>Inga scheman</i></div>
                </div>
            </div>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>

        <div id="modal_schedule" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="schedule">
                    <div class="modal-header">
                        <h5 v-if="schedule.schedule.id > 0" class="modal-title">Redigera schema</h5>
                        <h5 v-else class="modal-title">Nytt schema</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <ValidationObserver ref="scheduleform">
                            <form @submit.prevent="saveSchedule">
                                <div class="row">
                                    <label class="col-form-label col-xl-2 font-weight-semibold">Gäller fr.o.m.:</label>
                                    <ValidationProvider tag="div" class="col-xl-10" vid="schedule.valid_from" name="Gäller fr.o.m" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <v-date-picker
                                                v-model="schedule.schedule.valid_from"
                                                mode="date"
                                                :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                                :masks="{ input: 'YYYY-MM-DD' }"
                                            >
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                </template>
                                            </v-date-picker>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div v-if="schedule.times.length === 0" class="row">
                                    <label class="col-form-label col-xl-2 font-weight-semibold">Sysselsättningsgrad:</label>
                                    <ValidationProvider tag="div" class="col-xl-10" vid="schedule.workpercentage" name="Sysselsättningsgrad" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <div class="input-group">
                                            <input type="number" v-model="schedule.schedule.workpercentage" class="form-control">
                                                <div class="input-group-append">
                                                    <span class="input-group-text">%</span>
                                                </div>
                                            </div>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>

                                <div
                                    v-for="(times, week) in schedule.times"
                                    :key="'w-' + week"
                                    class="mb-4"
                                >
                                    <div class="row border-top">
                                        <div class="col-6 font-weight-semibold py-2">Vecka {{ week + 1 }}</div>
                                        <div class="col-6 font-weight-semibold pt-2 text-right">
                                            <button
                                                type="button"
                                                class="btn btn-danger btn-sm"
                                                @click="deleteWeek(week)"
                                            >
                                                <i class="icon-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 font-weight-semibold py-2">Dag</div>
                                        <div class="col-2 font-weight-semibold text-center py-2">Börjar</div>
                                        <div class="col-2 font-weight-semibold text-center py-2">Slutar</div>
                                        <div class="col-2 font-weight-semibold text-center py-2">Rast (min)</div>
                                        <div class="col-2 font-weight-semibold text-center py-2">Frånvarotyp</div>
                                        <div class="col-2 font-weight-semibold text-center py-2">Frånvarotid (min)</div>
                                    </div>
                                    <div
                                        class="row"
                                        v-for="(time, t_index) in times"
                                        :key="'w-' + week + '-t-' + t_index"
                                    >
                                        <label class="col-form-label col-xl-2">{{ days[time.day - 1] }}</label>
                                        <ValidationProvider tag="div" class="col-2" :vid="'times.' + week + '.' + t_index + '.start_of_day'" name="Börjar" v-slot="{ errors }">
                                            <div class="form-group mb-1">
                                                <input type="time" class="form-control" v-model="time.start_of_day" :class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <ValidationProvider tag="div" class="col-2" :vid="'times.' + week + '.' + t_index + '.end_of_day'" name="Slutar" v-slot="{ errors }">
                                            <div class="form-group mb-1">
                                                <input type="time" class="form-control" v-model="time.end_of_day" :class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <ValidationProvider tag="div" class="col-2" :vid="'times.' + week + '.' + t_index + '.break'" name="Rast" v-slot="{ errors }">
                                            <div class="form-group mb-1">
                                                <input type="number" step="15" min="0" class="form-control" v-model="time.break" :class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <ValidationProvider tag="div" class="col-2" :vid="'times.' + week + '.' + t_index + '.absence_cause_code'" name="Rast" v-slot="{ errors }">
                                            <div class="form-group mb-1">
                                                <cause-code-filter
                                                    v-model="time.absence_cause_code"
                                                    :reduce="(opt) => opt.id"
                                                ></cause-code-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <ValidationProvider tag="div" class="col-2" :vid="'times.' + week + '.' + t_index + '.absence_minutes'" name="Rast" v-slot="{ errors }">
                                            <div class="form-group mb-1">
                                                <input type="number" step="15" min="0" class="form-control" v-model="time.absence_minutes" :class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-light"
                                        @click="addWeek"
                                    >
                                        <i class="icon-plus3 mr-2"></i>Lägg till vecka
                                    </button>
                                </div>

                                <div v-if="schedule.times.length > 0" class="alert alert-info alert-styled-left mt-3">
                                    Om frånvaro anges i arbetsschemat kommer angivet antal minuter registreras i Fortnox utöver registrerade tidrader.
                                </div>
                            </form>
                        </ValidationObserver>
                        <div class="text-muted mt-4">Skapad {{ formatDateTime(schedule.schedule.created_at) }}<span v-if="schedule.schedule.created_by_user"> av {{ schedule.schedule.created_by_user.name }}</span></div>
                        <div class="text-muted">Senast ändrad {{ formatDateTime(schedule.schedule.updated_at) }}<span v-if="schedule.schedule.updated_by_user"> av {{ schedule.schedule.updated_by_user.name }}</span></div>
                    </div>
                    <div class="modal-footer">
                        <div class="mr-auto">
                            <limitless-button ref="btndeleteschedule" type="button" btn-class="btn-danger" icon="icon-cross2" @click="deleteSchedule" :busy="busy_saving">RADERA</limitless-button>
                        </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        <limitless-button ref="btnsaveschedule" type="button" @click="saveSchedule" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Redigera schema</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <i style="color:red;">Kunde ej ladda data</i>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { formatDateTime } from '@services/Helpers';
import CauseCodeFilter from '@components/Filters/CauseCodeFilter.vue';
import InputWithValidation
    from '@components/Form/InputWithValidation.vue';

export default {
    name: 'UserEdit',
    components: {
        InputWithValidation,
        CauseCodeFilter,
        VDatePicker,
        LimitlessButton,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_saving: false,
        not_found: false,
        user: null,
        schedules: [],
        schedule: null,
        days: ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'],
    }),
    mounted() {
        this.getUser();
        this.getSchedules();
    },
    methods: {
        formatDateTime,
        getUser() {
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    this.user = response.data.user;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async saveEmployment() {
            const isValid = await this.$refs.employmentform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/users/' + this.id + '/employment', this.user)
                    .then((response) => {
                        this.user = response.data.user;
                        this.$refs.btnsaveemployment.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.employmentform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveemployment.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        getSchedules() {
            apiClient.get('/vue/users/' + this.id + '/schedules')
                .then((response) => {
                    this.schedules = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async saveSchedule() {
            const isValid = await this.$refs.scheduleform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/users/' + this.id + '/schedules/' + this.schedule.schedule.id, this.schedule)
                    .then((response) => {
                        this.schedule = response.data;
                        this.$refs.btnsaveschedule.triggerSaved();
                        this.getSchedules();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.scheduleform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveschedule.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        deleteSchedule() {
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Är du säker på att du vill ta bort detta schema?')) {
                this.busy_saving = true;
                apiClient.delete('/vue/users/' + this.id + '/schedules/' + this.schedule.schedule.id)
                    .then(() => {
                        $('#modal_schedule').modal('hide');
                        this.getSchedules();
                        this.schedule = null;
                    })
                    .catch(() => {
                        this.$refs.btndeleteschedule.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        editSchedule(scheduleId) {
            this.busy_saving = true;
            $('#modal_schedule').modal('show');
            apiClient.get('/vue/users/' + this.id + '/schedules/' + scheduleId)
                .then((response) => {
                    this.schedule = response.data;
                })
                .finally(() => {
                    this.busy_saving = false;
                });
        },
        addWeek() {
            if (this.schedule) {
                let week = -1;
                Object.keys(this.schedule.times).forEach((objWeek) => {
                    if (parseInt(objWeek, 10) > week) {
                        week = parseInt(objWeek, 10);
                    }
                });
                week += 1;
                const newWeek = [];
                for (let i = 1; i <= 7; i += 1) {
                    newWeek.push({
                        id: 0,
                        week: week + 1,
                        day: i,
                        start_of_day: null,
                        end_of_day: null,
                        break: null,
                    });
                }
                this.$set(this.schedule.times, week, newWeek);
            }
        },
        deleteWeek(week) {
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Är du säker på att du vill ta bort denna vecka?')) {
                this.$delete(this.schedule.times, week);
            }
        },
    },
};

</script>
